export function getExtension(fileName: string) {
  const parts = fileName.split('.')
  return parts[parts.length - 1]?.toLowerCase()
}

/**
 * Only supports mp3, wav, ogg, webm, and flac
 */
export function getMimeType(fileName: string) {
  const extension = getExtension(fileName)
  switch (extension) {
    case 'mp3':
      return 'audio/mpeg'
    case 'wav':
      return 'audio/wav'
    case 'ogg':
      return 'audio/ogg'
    case 'webm':
      return 'audio/webm'
    case 'flac':
      return 'audio/flac'
    default:
      throw new Error(`Unsupported extension: ${extension}`)
  }
}
